import React from 'react'
import { Card, Form, Row, Col, Alert } from 'react-bootstrap'
import { OPCIONES_TIPOS_PEDIDO_PARA_FILTRO } from 'config/pedidos'
import UserSelector from 'components/UserSelector'
import './GeneralTab.css'

function GeneralTab({
	data = {},
	onChange,
	cliente,
	onClienteChange,
	disabled = false,
	clienteReadOnly = false,
	clienteReadOnlyReason = '',
	erroresValidacion = {}
}) {
	const handleChange = (campo, valor) => {
		// Crear objeto con el campo que cambió
		onChange({ [campo]: valor })
	}

	const handleClienteChange = (nuevoCliente) => {
		onClienteChange(nuevoCliente)
	}

	return (
		<Card className="shadow-sm">
			<Card.Header className="bg-light">
				<h6 className="mb-0">
					<i className="fa fa-info-circle me-2"></i>
					Información General
				</h6>
			</Card.Header>
			<Card.Body>
				<Form>
					<Row>
						<Col md={6}>
							<Form.Group className="mb-3" controlId="tipo">
								<Form.Label>Tipo de Pedido</Form.Label>
								<Form.Select
									value={data.tipo || ''}
									onChange={(e) => handleChange('tipo', e.target.value)}
									isInvalid={!!erroresValidacion.tipo}
									disabled={disabled}
								>
									<option value="">Seleccionar tipo...</option>
									{OPCIONES_TIPOS_PEDIDO_PARA_FILTRO.map(tipo => (
										<option key={tipo.value} value={tipo.value}>
											{tipo.label}
										</option>
									))}
								</Form.Select>
								<Form.Control.Feedback type="invalid">
									{erroresValidacion.tipo}
								</Form.Control.Feedback>
								<Form.Text className="text-muted">
									Cambiar el tipo puede afectar las opciones de entrega
								</Form.Text>
							</Form.Group>
						</Col>
						<Col md={6}>
							<Form.Group className="mb-3">
								<Form.Label>
									Cliente
									{clienteReadOnly && (
										<i className="fa fa-lock ms-2 text-warning" title={clienteReadOnlyReason}></i>
									)}
								</Form.Label>

								{clienteReadOnly ? (
									// Si está en modo solo lectura, mostrar campo deshabilitado
									<Form.Control
										type="text"
										value={cliente ?
											`${cliente.nombre} ${cliente.apellido} - ${cliente.email}` :
											'Cliente no especificado'
										}
										disabled
										className="general-cliente-readonly"
									/>
								) : (
									// Si es editable, mostrar selector
									<UserSelector
										value={cliente}
										onChange={handleClienteChange}
										placeholder="Buscar y seleccionar cliente..."
										showEmail={true}
										showPhone={false}
										disabled={disabled}
									/>
								)}

								{clienteReadOnly && clienteReadOnlyReason && (
									<Form.Text className="text-warning">
										<i className="fa fa-exclamation-triangle me-1"></i>
										{clienteReadOnlyReason}
									</Form.Text>
								)}

								{!clienteReadOnly && (
									<Form.Text className="text-muted">
										Busque por nombre, email, teléfono o usuario
									</Form.Text>
								)}
							</Form.Group>
						</Col>
					</Row>

					{/* Sección de Observaciones - AMBOS CAMPOS EDITABLES */}
					<Row>
						{/* Observaciones del Cliente - EDITABLE */}
						<Col md={6}>
							<Form.Group className="mb-3" controlId="observaciones">
								<Form.Label>
									<i className="fa fa-user me-2 text-primary"></i>
									Observaciones del Cliente
								</Form.Label>
								<Form.Control
									as="textarea"
									rows={4}
									value={data.observaciones || ''}
									onChange={(e) => handleChange('observaciones', e.target.value)}
									isInvalid={!!erroresValidacion.observaciones}
									placeholder="Observaciones que dejó el cliente al realizar el pedido..."
									maxLength={500}
									disabled={disabled}
									className="general-observaciones border-primary"
								/>
								<Form.Control.Feedback type="invalid">
									{erroresValidacion.observaciones}
								</Form.Control.Feedback>
								<Form.Text className="text-primary">
									<i className="fa fa-user me-1"></i>
									Comentarios del cliente sobre el pedido.
									<br />
									<small>Caracteres: {(data.observaciones || '').length}/500</small>
								</Form.Text>
							</Form.Group>
						</Col>

						{/* Observaciones Internas - EDITABLE */}
						<Col md={6}>
							<Form.Group className="mb-3" controlId="observacionesInternas">
								<Form.Label>
									<i className="fa fa-lock me-2 text-warning"></i>
									Observaciones Internas
								</Form.Label>
								<Form.Control
									as="textarea"
									rows={4}
									value={data.observacionesInternas || ''}
									onChange={(e) => handleChange('observacionesInternas', e.target.value)}
									isInvalid={!!erroresValidacion.observacionesInternas}
									placeholder="Notas internas sobre el pedido (solo visible para el equipo)..."
									maxLength={1000}
									disabled={disabled}
									className="general-observaciones border-warning"
								/>
								<Form.Control.Feedback type="invalid">
									{erroresValidacion.observacionesInternas}
								</Form.Control.Feedback>
								<Form.Text className="text-warning">
									<i className="fa fa-eye-slash me-1"></i>
									Notas privadas del equipo. No visibles para el cliente.
									<br />
									<small>Caracteres: {(data.observacionesInternas || '').length}/1000</small>
								</Form.Text>
							</Form.Group>
						</Col>
					</Row>

					{/* Información adicional sobre el comportamiento */}
					{data.tipo && (
						<div className="general-info-tipo">
							<Alert variant="info" className="mb-0">
								<i className="fa fa-info-circle me-2"></i>
								<strong>Tipo seleccionado:</strong> {OPCIONES_TIPOS_PEDIDO_PARA_FILTRO.find(t => t.value === data.tipo)?.label || data.tipo}
								<br />
								<small>
									Este tipo de pedido determinará las opciones disponibles en las demás pestañas.
								</small>
							</Alert>
						</div>
					)}
				</Form>
			</Card.Body>
		</Card>
	)
}

export default GeneralTab